import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthProvider';
import LanguageSelector from '../components/LanguageSelector';

const LoginOTPPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { sendOTP, verifyOTP } = useAuth();

  const [phoneNumber, setPhoneNumber] = useState('+91');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSendOTP = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await sendOTP(phoneNumber);
      setOtpSent(true);
    } catch (error) {
      setError(error.message || 'Failed to send OTP');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const { isNewUser } = await verifyOTP(phoneNumber, otp);
      if (isNewUser) {
        navigate('/profile', { replace: true });
      } else {
        navigate('/profile', { replace: true });
      }
    } catch (error) {
      setError(error.message || 'Invalid OTP');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    if (otpSent) {
      setOtpSent(false);
      setOtp('');
      setError('');
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="app-container" style={{ background: 'linear-gradient(rgb(11, 58, 122) 0%, rgb(11, 35, 74) 100%)', minHeight: '100vh' }}>
      <div className="splash-screen">
        <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
          <LanguageSelector />
        </div>

        <h1 className="brand-title">{t('common.brand')}</h1>
        <p className="brand-tagline">"{t('common.tagline')}"</p>

        <div className="auth-card fade-in">
          {!otpSent ? (
            <form onSubmit={handleSendOTP}>
              <h2 className="text-center mb-2">{t('auth.phoneTitle')}</h2>

              <div className="form-group">
                <input
                  type="tel"
                  className="form-input"
                  placeholder={t('auth.phone')}
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  required
                />
              </div>

              {error && (
                <div style={{ color: 'red', marginBottom: '1rem', textAlign: 'center' }}>
                  {error}
                </div>
              )}

              <button 
                type="submit" 
                className="btn-primary"
                disabled={loading}
              >
                {loading ? t('common.loading') : t('auth.getOtp')}
              </button>

              <button 
                type="button" 
                className="btn-secondary"
                onClick={handleBack}
              >
                {t('common.back')}
              </button>
            </form>
          ) : (
            <form onSubmit={handleVerifyOTP}>
              <h2 className="text-center mb-2">{t('auth.verifyOtp')}</h2>
              <p className="text-center mb-2" style={{ color: '#666' }}>
                OTP sent to {phoneNumber}
              </p>

              <div className="form-group">
                <input
                  type="text"
                  className="form-input"
                  placeholder={t('auth.otp')}
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  maxLength="6"
                  required
                />
              </div>

              {error && (
                <div style={{ color: 'red', marginBottom: '1rem', textAlign: 'center' }}>
                  {error}
                </div>
              )}

              <button 
                type="submit" 
                className="btn-primary"
                disabled={loading}
              >
                {loading ? t('common.loading') : t('auth.verifyOtp')}
              </button>

              <button 
                type="button" 
                className="btn-secondary"
                onClick={handleBack}
              >
                {t('common.back')}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginOTPPage;